import React from 'react';

/**
 * Contains CSS defining the maximum height of the application, or `undefined` if no maximum height
 * exists.
 */
export const MaxHeight = React.createContext(undefined);
